class HandlerToSkuOrganizationPriceListForm {
    constructor(appliedTaxField, taxField, skuTaxTypeField) {
        this.appliedTaxField = appliedTaxField;
        this.taxField = taxField;
        this.skuTaxTypeField = skuTaxTypeField;

        this.skuTaxTypeField.afterSelectValue = this.setTaxTypeConfigs;

        this.taxField.hide = function() {
            this.isHidden = true;
            this.rootEl.style.display = "none";
        }

        this.appliedTaxField.hide = function() {
            this.isHidden = true;
            this.rootEl.style.display = "none";
        }
    }

    formatOptionsLayout() {
        const options = this.skuTaxTypeField.rootEl.querySelectorAll('.radio_group_item');
        const optionsWrapper =  document.createElement('div');

        optionsWrapper.classList.add('optionsWrapper');
        optionsWrapper.classList.add('radio_group_item')

        options.forEach((option) => optionsWrapper.appendChild(option));

        this.skuTaxTypeField.rootEl.appendChild(optionsWrapper);
    }

    addEventListenerToTaxTypeField = () => {
        let options = this.skuTaxTypeField.rootEl.querySelectorAll('.radio_group_item > input[type="radio"]');

        options.forEach(option => {
            option.addEventListener('click', this.setTaxTypeConfigs);
        });
    }

    setTaxTypeConfigs = () => {
        const skuTaxTypeFieldOption = this.skuTaxTypeField.getValue();

        if(skuTaxTypeFieldOption === 'PERCENT') {
            this.taxField.hide();
            this.appliedTaxField.show();
        } else {
            this.taxField.show();
            this.appliedTaxField.hide();
        }
    }

    init = () => {
        this.setTaxTypeConfigs();
        this.addEventListenerToTaxTypeField();
        this.formatOptionsLayout();
    }
}


/* Model */
class SkuOrganizationPriceListModel extends App.Models.BaseModel {
    modelUrl = 'SkuOrganizationPriceList';
}

App.Models.SkuOrganizationPriceList = SkuOrganizationPriceListModel;

/* Collection */
class SkuOrganizationPriceListCollection extends App.Collections.BaseCollection {
    url = 'SkuOrganizationPriceList';
    model = App.Models.SkuOrganizationPriceList;
}

App.Collections.SkuOrganizationPriceLists = SkuOrganizationPriceListCollection;

/* Router */
class SkuOrganizationPriceListRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'SkuOrganizationPriceList';
        const model = App.Models.SkuOrganizationPriceList;
        const collectionClass = App.Collections.SkuOrganizationPriceLists;

        super(entityName, model, collectionClass);
    }

    afterCreateForm = () => {
        const fields = App.Forms.SkuOrganizationPriceList.form.fields;

        const {
            appliedTax,
            tax,
            skuTaxType,
        } = fields;

        const skuOrganizationPriceListFormHandler = new HandlerToSkuOrganizationPriceListForm(
            appliedTax,
            tax,
            skuTaxType,
        );

        App.Forms.SkuOrganizationPriceListFormHandler = skuOrganizationPriceListFormHandler;
        skuOrganizationPriceListFormHandler.init();
    }
}

App.Routers.SkuOrganizationPriceList = SkuOrganizationPriceListRouter;
